"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimarySupernet = exports.Supernet = exports.MCN = void 0;
const PrimarySupernetName = 'Primary Supernet';
class MCN {
    name;
    url;
    id;
    hrp;
    primary;
    supernets;
    constructor(name, url, id, hrp, primary, supernets = [primary]) {
        this.name = name;
        this.url = url;
        this.id = id;
        this.hrp = hrp;
        this.primary = primary;
        this.supernets = supernets;
    }
    getChain(chainId) {
        for (const supernet of this.supernets) {
            const chain = supernet.getSupernetChain(chainId);
            if (chain !== undefined) {
                return chain;
            }
        }
        throw new Error(`no registered chain with id ${chainId} in ${this.name}`);
    }
}
exports.MCN = MCN;
class Supernet {
    name;
    id;
    chains;
    constructor(name, id, chains) {
        this.name = name;
        this.id = id;
        this.chains = chains;
    }
    getSupernetChain(chainId) {
        for (const chain of this.chains) {
            if (chain.id === chainId) {
                return chain;
            }
        }
        throw new Error(`no registered chain with id ${chainId} in supernet ${this.name}`);
    }
}
exports.Supernet = Supernet;
class PrimarySupernet extends Supernet {
    platform;
    jvm;
    june;
    constructor(id, chains, platform, jvm, june) {
        super(PrimarySupernetName, id, chains);
        this.platform = platform;
        this.jvm = jvm;
        this.june = june;
    }
}
exports.PrimarySupernet = PrimarySupernet;
